import { addContentPath } from './pathUtil';

/**
 * 获取查询参数
 *
 * @param {*} search
 */
export const getSearchParams = (search) => {
    const searchParams = {};

    if (search) {
        const params = search.slice(search.indexOf('?') + 1).split('&');
        for (let i = 0, len = params.length; i < len; i++) {
            const item = params[i].split('=');
            searchParams[item[0]] = item[1];
        }
    }

    return searchParams;
};

/**
 * js异步加载
 *
 * @param src           js文件路径
 * @param callbackfunc  js执行完的回调函数
 */
export const jsAsyncLoad = (src, callbackfunc) => {
    const body = document.getElementsByTagName('body')[0];
    const script = document.createElement('script');
    script.id = `theme-plugin-${new Date().getTime()}`;
    script.type = 'text/javascript';
    script.src = addContentPath(src);
    if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                if (callbackfunc && typeof callbackfunc == 'function') {
                    callbackfunc();
                }
            }
        };
    } else {
        script.onload = () => {
            if (callbackfunc && typeof callbackfunc == 'function') {
                callbackfunc();
            }
        };
    }
    body.appendChild(script);
};

/**
 * css异步加载
 *
 * @param href          css文件路径
 * @param callbackfunc  css加载完的回调函数
 */
export const cssAsyncLoad = (href, callbackfunc) => {
    const body = document.getElementsByTagName('body')[0];
    const link = document.createElement('link');
    link.id = `theme-plugin-${new Date().getTime()}`;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = addContentPath(href);
    if (link.readyState) {
        // IE
        link.onreadystatechange = () => {
            if (link.readyState == 'loaded' || link.readyState == 'complete') {
                link.onreadystatechange = null;
                if (callbackfunc && typeof callbackfunc == 'function') {
                    callbackfunc();
                }
            }
        };
    } else {
        link.onload = () => {
            if (callbackfunc && typeof callbackfunc == 'function') {
                callbackfunc();
            }
        };
    }
    body.appendChild(link);
};

/**
 * 格式化菜单数据
 *
 * @param data 菜单数据
 * @returns {Array}
 */
export const formatMenuData = (data, topId, pathIds) => {
    let result = [];

    for (let i = 0, len = data.length; i < len; i++) {
        const item = data[i] || {};
        const id = item.infoId || item.id;
        const parentId = item.parentId || '0';
        const isPortalMenu = !!item.hpid;
        const url = item.linkAddress || item.url || '';

        // 添加路径
        const _topId = topId || id;
        const _pathIds = pathIds ? `${pathIds},${id}` : id;

        result.push({
            topId: _topId,
            pathIds: _pathIds,
            infoId: id,
            parentId,
            id: `${(isPortalMenu ? 'portal_' : '') + parentId}-${id}`,
            hpid: item.hpid || '',
            numId: isPortalMenu ? `portal_${item.hpid}` : id,
            levelid: `${parentId}-${
                isPortalMenu
                    ? item.levelid && item.pid == '0'
                    ? `${item.levelid.split('_')[0] % 20}_portal`
                    : item.levelid || '0'
                    : item.levelid
                }`,
            name: item.name || '',
            fname: item.fname || '',
            pinyin: item.pinyin || '',
            url: url && url.replace(/&#38;/g, '&'),
            routeurl: item.routeurl || '',
            mobxrouteurl: item.mobxrouteurl || '',
            fullrouteurl: item.fullrouteurl || '',
            target: item.target || 'mainFrame',
            icon: item.icon || '',
            iconType: item.iconType,
            iconImgSrc: item.iconImgSrc,
            child: item.child ? formatMenuData(item.child, _topId, _pathIds) : [],
            count: item.count != undefined ? item.count : '',
            countId: item.countId || '',
            titleUrl: item.titleUrl || '',
            titleUrlIcon: item.titleUrlIcon || '',
            titleUrlName: item.titleUrlName || '',
            tagColor: item.tagColor || '',
            hasTopLine: item.hasTopLine || '',
        });
    }

    return result;
};

/**
 * 设置字体大小
 *
 * @param fontSize 字体大小
 */
export const setFontSize = (fontSize) => {
    jQuery('#theme-font').remove();
    const href = `/cloudstore/resource/pc/com/font-size/${fontSize}px.css`;
    jQuery(jQuery('head')[0]).append(`<link id="theme-font" rel="stylesheet" type="text/css" href="${addContentPath(href)}" />`);
};

/**
 * 获取E9主题样式
 *
 * @param data E9主题样式配置数据
 */
export const getE9ThemeCss = (data,leftMenuMode) => {
    const {
        header = {},
        toplogo = {},
        topmenu = {},
        frequsemenu = {},
        leftmenuswitch = {},
        leftmenu = {},
        navmenu = {},
        leftmenu3 = {},
        leftmenu4switch = {},
        leftmenu4 = {},
        main = {},
    } = data;
    const css = [];
	let leftMenuWidth=leftmenu.leftMenuAreaWidth || '197px'
	if(leftMenuMode == 'inline'){
        css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-inline {width:${leftMenuWidth }  !important}`);
    }
	css.push(`.e9theme-layout3-content .e9theme-layout3-left {width:${leftmenu3.leftMenuAreaWidth || '197px' }  !important}`);

    css.push(`.e9header-container {color:${header.color};font-size:${header.fontSize};font-family:${header.fontFamily};background:${header.background};} `);
    css.push(`.e9header-container .e9header-top-logo {color:${toplogo.color};font-size:${toplogo.fontSize};font-family:${toplogo.fontFamily};background:${toplogo.background};} `);
    if (header.backgroundImage) {
        css.push(`.e9header-container .e9header-right {background:url(${addContentPath(header.backgroundImage)}) center center / 100% 100% no-repeat;} `);
    }

    css.push(`.e9header-container .e9header-top-menu2-open {background:${topmenu.openedBackground || header.background};} `);
    css.push(`.e9header-container .e9header-top-menu2-open .e9header-top-menu2-content {height:auto;background:${topmenu.openedBackground || frequsemenu.background};} `);
    css.push(`.e9header-container .e9header-top-menu2-item-selected {color:${topmenu.selectedColor};} `);
    css.push('.e9header-container .e9header-top-menu2-btn {background:rgba(0, 0, 0, 0.08);} ');
    css.push('.e9header-container .e9header-top-menu2-btn:hover {background:rgba(0, 0, 0, 0.14);} ');
    css.push('.e9header-container .e9header-top-menu2-open .e9header-top-menu2-btn {background:none;} ');

    css.push('.e9header-container .e9header-freq-use-menu {background:rgba(0, 0, 0, 0.08);} ');
    css.push('.e9header-container .e9header-freq-use-menu:hover {background:rgba(0, 0, 0, 0.14);} ');

    css.push('.e9header-container .e9header-quick-search {background:rgba(0, 0, 0, 0.08);} ');
    css.push('.e9header-container .e9header-quick-search:hover {background:rgba(0, 0, 0, 0.14);} ');

    css.push('.e9theme-layout-aside .e9aside-container [class*=wevicon-menu],');
    css.push(`.e9theme-layout-aside .e9aside-container [class^=wevicon-menu] {font-family:${leftmenu.iconstyle == 'line' ? 'wevicon-line' :'wevicon'} !important;} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline,');
    css.push('.e9theme-layout-aside .e9aside-container .ant-menu-inline,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical,');
    css.push(`.e9theme-layout-aside .e9aside-container .ant-menu-vertical {background:${leftmenu.background};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .wea-menu-switch,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .wea-menu-switch {background:${leftmenuswitch.background};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .wea-menu-switch i,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .wea-menu-switch i {color:${leftmenuswitch.color};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-item,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-submenu-title {color:${leftmenu.titleColor};font-family:${leftmenu.titleFontFamily};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-item .wea-menu-title,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-submenu-title .wea-menu-title,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-item .wea-menu-title,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-title .wea-menu-title {font-size:${leftmenu.titleFontSize};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-item .wevicon,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-submenu-title .wevicon,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-item .wevicon,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-title .wevicon {color:${leftmenu.iconColor};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .wea-menu-selected,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-item-active,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-submenu-title:hover {color:${leftmenu.selectedTitleColor} !important;background:${leftmenu.selectedTitleBackground} !important;} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .wea-menu-selected .wevicon,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-item-active .wevicon,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-inline .ant-menu-submenu-title:hover .wevicon {color:${leftmenu.selectedIconColor} !important;} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-item-active:before,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-submenu-active:before {border:2px solid ${leftmenu.selectedTitleBackground};border-top:21px solid ${leftmenu.selectedTitleBackground};border-bottom:21px solid ${leftmenu.selectedTitleBackground};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-item-active,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-submenu-active {color:inherit;background:${leftmenu.vBackground};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .wea-menu-selected .wevicon,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-active .wevicon,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-selected .wevicon,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-title:hover .wevicon {color:${leftmenu.vSelectedIconColor} !important;} `);

    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-sub {color:${leftmenu.vColor};font-family:${leftmenu.titleFontFamily};background:${leftmenu.vBackground};} `);

    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .wea-menu-selected,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-selected,');
    css.push('.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-item-active,');
    css.push(`.e9theme-layout-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-submenu-active {color:${leftmenu.vSelectedTitleColor} !important;background:${leftmenu.vSelectedTitleBackground} !important;} `);

    const headerBackground = header.background && header.background.toLowerCase();
    const headerColor = header.color;
    const background = headerBackground != '#fff' && headerBackground != '#ffffff' ? headerBackground : headerColor;

    css.push(`.e9left-menu-email-item {color:#fff;background:${background};} `);
    css.push('.e9left-menu-email-item-selected {color:#003666;background:#f6f6f6;} ');
    css.push('.e9left-menu-email-item-ul {color:#003666;background:#f6f6f6;} ');
    css.push('.e9left-menu-email-item-ul li:hover {background:#dadfe3;} ');

    // 顶部栏显示
    css.push(`.e9theme-layout2-navbar .e9navbar-container {font-size:${navmenu.titleFontSize || leftmenu.titleFontSize};font-family:${navmenu.titleFontFamily || leftmenu.titleFontFamily};background:${navmenu.background || '#ffffff'};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .e9navbar-prev, .e9theme-layout2-navbar .e9navbar-container .e9navbar-next {background:${navmenu.background || '#ffffff'};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .e9navbar-top-menu-icon i {color:${navmenu.iconColor || '#859097'};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .ant-tabs-tab-next-icon, .e9theme-layout2-navbar .e9navbar-container .ant-tabs-tab-prev-icon {color:${navmenu.iconColor || '#859097'}} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root {color:${navmenu.titleColor || '#333333'};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .e9navbar-e9submenu-selected > .pt-menu-submenu-title .e9navbar-top-menu-icon i,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-submenu-active > .pt-menu-submenu-title .e9navbar-top-menu-icon i,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-submenu-selected > .pt-menu-submenu-title .e9navbar-top-menu-icon i,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-item-active > .pt-menu-item-title .e9navbar-top-menu-icon i,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-item-selected > .pt-menu-item-title .e9navbar-top-menu-icon i {color:${navmenu.selectedIconColor || '#ffffff'};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .e9navbar-e9submenu-selected > .pt-menu-submenu-title,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-submenu-active > .pt-menu-submenu-title,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-submenu-selected > .pt-menu-submenu-title,`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-item-active > .pt-menu-item-title,`)
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-item-selected > .pt-menu-item-title {color:${navmenu.selectedTitleColor || '#ffffff'};background:${navmenu.selectedTitleBackground || background};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-item-active {background:transparent;} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-item-selected {background:transparent;} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container .pt-menu-root > .pt-menu-submenu-selected {background:transparent;} `);
    css.push(`.e9navbar-sub-container {font-size:${navmenu.titleFontSize || leftmenu.titleFontSize};} `);
    css.push(`.e9navbar-sub-container.pt-menu-submenu > .pt-menu {color:${navmenu.vColor || '#333333'};font-family:${navmenu.titleFontFamily || leftmenu.titleFontFamily};background:${navmenu.vBackground || '#ffffff'};} `);
    css.push(`.e9navbar-sub-container.pt-menu-submenu > .pt-menu .e9navbar-e9submenu-selected,`);
    css.push(`.e9navbar-sub-container.pt-menu-submenu > .pt-menu .pt-menu-item-selected,`);
    css.push(`.e9navbar-sub-container.pt-menu-submenu > .pt-menu .pt-menu-item-active,`);
    css.push(`.e9navbar-sub-container.pt-menu-submenu > .pt-menu .pt-menu-submenu-selected,`);
    css.push(`.e9navbar-sub-container.pt-menu-submenu > .pt-menu .pt-menu-submenu-active > .pt-menu-submenu-title {color:${navmenu.vSelectedTitleColor || '#333333'};background:${navmenu.vSelectedTitleBackground || '#eaf8fe'};} `);
    css.push(`.e9theme-layout2-navbar .e9navbar-container [class*=wevicon],`);
    css.push(`.e9theme-layout2-navbar .e9navbar-container [class^=wevicon] {font-family:${(navmenu.iconstyle || 'solid') == 'line' ? 'wevicon-line' :'wevicon'} !important;} `);

    // 左侧栏显示
    css.push(`.e9theme-layout3-left .e9left-container {font-size:${leftmenu3.titleFontSize || leftmenu.titleFontSize};font-family:${leftmenu3.titleFontFamily || leftmenu.titleFontFamily};background:${leftmenu3.background || '#ffffff'};} `);
    css.push(`.e9theme-layout3-left .e9left-container .e9aside-top-menu-icon i {color:${leftmenu3.iconColor || '#859097'};} `);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root {color:${leftmenu3.titleColor || '#333333'};} `);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .e9left3-e9submenu-selected > .pt-menu-submenu-title .e9aside-top-menu-icon i,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-submenu-active > .pt-menu-submenu-title .e9aside-top-menu-icon i,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-submenu-selected > .pt-menu-submenu-title .e9aside-top-menu-icon i,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-item-active > .pt-menu-item-title .e9aside-top-menu-icon i,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-item-selected > .pt-menu-item-title .e9aside-top-menu-icon i {color:${leftmenu3.selectedIconColor || '#ffffff'};} `);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .e9left3-e9submenu-selected > .pt-menu-submenu-title,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-submenu-active > .pt-menu-submenu-title,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-submenu-selected > .pt-menu-submenu-title,`);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-item-active > .pt-menu-item-title,`)
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-item-selected > .pt-menu-item-title {color:${leftmenu3.selectedTitleColor || '#ffffff'};background:${leftmenu3.selectedTitleBackground || background};} `);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-item-active {background:transparent;} `);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-item-selected {background:transparent;} `);
    css.push(`.e9theme-layout3-left .e9left-container .pt-menu-root > .pt-menu-submenu-selected {background:transparent;} `);
    css.push(`.e9left-sub-container {font-size:${leftmenu3.titleFontSize || leftmenu.titleFontSize};} `);
    css.push(`.e9left-sub-container.pt-menu-submenu > .pt-menu {color:${leftmenu3.vColor || '#333333'};font-family:${leftmenu3.titleFontFamily || leftmenu3.titleFontFamily};background:${leftmenu3.vBackground || '#ffffff'};} `);
    css.push(`.e9left-sub-container.pt-menu-submenu > .pt-menu .e9left3-e9submenu-selected,`);
    css.push(`.e9left-sub-container.pt-menu-submenu > .pt-menu .pt-menu-item-selected,`);
    css.push(`.e9left-sub-container.pt-menu-submenu > .pt-menu .pt-menu-item-active,`);
    css.push(`.e9left-sub-container.pt-menu-submenu > .pt-menu .pt-menu-submenu-selected,`);
    css.push(`.e9left-sub-container.pt-menu-submenu > .pt-menu .pt-menu-submenu-active > .pt-menu-submenu-title {color:${leftmenu3.vSelectedTitleColor || '#333333'};background:${leftmenu3.vSelectedTitleBackground || '#eaf8fe'};} `);
    css.push(`.e9theme-layout3-left .e9left-container [class*=wevicon],`);
    css.push(`.e9theme-layout3-left .e9left-container [class^=wevicon] {font-family:${(leftmenu3.iconstyle || 'solid') == 'line' ? 'wevicon-line' :'wevicon'} !important;} `);


    // 左侧栏显示(菜单下拉)
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container [class*=wevicon-menu],');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container [class^=wevicon-menu] {font-family:${leftmenu3.iconstyle == 'line' ? 'wevicon-line' :'wevicon'} !important;} `);
    css.push(`.e9theme-layout3-left .e9left-container .ant-menu-submenu-inline .ant-menu-submenu-title  i {color:${leftmenu3.iconColor || '#859097'};} `);
    //邮件菜单图标
    css.push(`.e9theme-layout3-left .e9left-container .text-elli i {color:${leftmenu3.iconColor || '#859097'};} `);


    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .ant-menu-inline,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .ant-menu-vertical {background:${leftmenu3.background};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .wea-menu-switch,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical .wea-menu-switch {background:${leftmenuswitch.background};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .wea-menu-switch i,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical .wea-menu-switch i {color:${leftmenuswitch.color};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-item,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-title {color:${leftmenu3.titleColor || '#333333'};font-family:${leftmenu3.titleFontFamily || leftmenu.titleFontFamily};} `);
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-sub .ant-menu-submenu-title {color:${leftmenu3.vColor || '#333333'};font-family:${leftmenu3.titleFontFamily || leftmenu.titleFontFamily};background:${leftmenu3.vBackground};} `);


    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-item .wea-menu-title,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-title .wea-menu-title,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical .ant-menu-item .wea-menu-title,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical .ant-menu-submenu-title .wea-menu-title {font-size:${leftmenu3.titleFontSize};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-item .wevicon,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-title .wevicon,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical .ant-menu-item .wevicon,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-vertical .ant-menu-submenu-title .wevicon {color:${leftmenu3.iconColor|| '#859097'};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root .wea-menu-selected,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root  .ant-menu-item-active,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root .ant-menu-submenu-title:hover {color:${leftmenu3.selectedTitleColor || '#ffffff'} !important;background:${leftmenu3.selectedTitleBackground || background} !important;} `);
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root .ant-menu-sub .ant-menu-submenu-title:hover {color:${leftmenu3.vSelectedTitleColor || '#333333'} !important;background:${leftmenu3.vSelectedTitleBackground || '#eaf8fe'} !important;} `);

    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root .ant-menu-sub .ant-menu-item:hover {color:${leftmenu3.vSelectedTitleColor || '#333333'} !important;background:${leftmenu3.vSelectedTitleBackground || '#eaf8fe'} !important;} `);


    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root .ant-menu-sub  .ant-menu-item-active {color:${leftmenu3.vSelectedTitleColor|| '#333333'} !important;background:${leftmenu3.vSelectedTitleBackground || '#eaf8fe'} !important;} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .wea-menu-selected .wevicon,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-item-active .wevicon,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-title:hover .wevicon {color:${leftmenu3.selectedIconColor|| '#ffffff'} !important;} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root > .ant-menu-item-active:before,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root > .ant-menu-submenu-active:before {border:2px solid ${leftmenu3.selectedTitleBackground};border-top:21px solid ${leftmenu3.selectedTitleBackground};border-bottom:21px solid ${leftmenu3.selectedTitleBackground};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root > .ant-menu-item-active,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-root > .ant-menu-submenu-active {color:inherit;background:${leftmenu3.vBackground};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .wea-menu-selected .wevicon,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-active .wevicon,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-selected .wevicon,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-title:hover .wevicon {color:${leftmenu3.vSelectedIconColor} !important;} `);

    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-sub {color:${leftmenu3.vColor  || '#333333'};font-family:${leftmenu3.titleFontFamily || leftmenu.titleFontFamily};background:${leftmenu3.vBackground};} `);
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-sub .ant-menu-item {color:${leftmenu3.vColor  || '#333333'};font-family:${leftmenu3.titleFontFamily || leftmenu.titleFontFamily};background:${leftmenu3.vBackground};} `);

    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-inline .ant-menu-inline .wea-menu-selected,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-selected,');
    css.push('.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-sub .ant-menu-item-active > .ant-menu-submenu-title ,');
    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-sub .ant-menu-submenu-active > .ant-menu-submenu-title {color:${leftmenu3.vSelectedTitleColor || '#333333'} !important;background:${leftmenu3.vSelectedTitleBackground || '#eaf8fe'} !important;} `);

    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-sub .ant-menu-submenu-active > .ant-menu-submenu-title {color:${leftmenu3.vSelectedTitleColor || '#333333'} !important;background:${leftmenu3.vSelectedTitleBackground || '#eaf8fe'} !important;} `);


    css.push(`.e9theme-layout3-left .e9aside-container.e9left-container .wea-menu-inline .ant-menu-submenu-inline .wea-menu-selected {color:${leftmenu3.selectedTitleColor || '#ffffff'} !important;background:${leftmenu3.selectedTitleBackground} !important;} `);

    css.push(`.e9left-menu-email-item {color:#fff;background:${background};} `);
    css.push('.e9left-menu-email-item-selected {color:#003666;background:#f6f6f6;} ');
    css.push('.e9left-menu-email-item-ul {color:#003666;background:#f6f6f6;} ');
    css.push('.e9left-menu-email-item-ul li:hover {background:#dadfe3;} ');


    // 极简显示
    css.push(`.e9theme-layout4-header .e9header-container .e9header-switch {color:${leftmenu4switch.color || header.color};background:${leftmenu4switch.background || background};} `)
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical,`);
    css.push(`.e9theme-layout4-aside .e9aside-container .ant-menu-vertical {background:${leftmenu4.background|| leftmenu.background};} `);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-title .wevicon {color:${leftmenu4.iconColor || leftmenu.iconColor};} `);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .wea-menu-selected .wevicon,`);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-selected .wevicon,`);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-active .wevicon {color:${leftmenu4.selectedIconColor || leftmenu.selectedIconColor} !important;} `);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-active:before {border:2px solid ${leftmenu4.vSelectedTitleBackground || leftmenu.vSelectedTitleBackground};border-top:21px solid ${leftmenu4.vSelectedTitleBackground || leftmenu.vSelectedTitleBackground};border-bottom:21px solid ${leftmenu4.vSelectedTitleBackground || leftmenu.vSelectedTitleBackground};} `);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-active {color:inherit;background:${leftmenu4.vBackground || leftmenu.vBackground};} `);
    css.push('.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .wea-menu-selected,');
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-submenu-selected {background:${leftmenu4.selectedTitleBackground || leftmenu.vSelectedTitleBackground} !important;} `);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub {color:${leftmenu4.vColor || leftmenu.vColor};font-family:${leftmenu4.titleFontFamily || leftmenu.titleFontFamily};font-size:${leftmenu3.titleFontSize || leftmenu.titleFontSize};background:${leftmenu4.vBackground || leftmenu.vBackground};} `);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .wea-menu-title {font-size:${leftmenu4.titleFontSize || leftmenu.titleFontSize};} `);
    css.push('.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .wea-menu-selected,');
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-item-selected,`);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-item-active,`);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-submenu-selected,`);
    css.push(`.e9theme-layout4-aside .e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-submenu-active {color:${leftmenu4.vSelectedTitleColor || leftmenu.vSelectedTitleColor} !important;background:${leftmenu4.vSelectedTitleBackground || leftmenu.vSelectedTitleBackground} !important;} `);
    css.push(`.e9theme-layout4-aside .e9aside-container [class*=wevicon-menu],`);
    css.push(`.e9theme-layout4-aside .e9aside-container [class^=wevicon-menu] {font-family:${(leftmenu4.iconstyle || leftmenu.iconstyle) == 'line' ? 'wevicon-line' :'wevicon'} !important;} `);

    // 中间区域背景
    css.push(`.e9theme-layout-content .e9theme-layout-main {background-color:${main.background || '#e8edf4'};} `);
    css.push(`.e9theme-layout2-content .e9theme-layout2-main {background-color:${main.background || '#e8edf4'};} `);
    css.push(`.e9theme-layout3-content .e9theme-layout3-main {background-color:${main.background || '#e8edf4'};} `);
    css.push(`.e9theme-layout4-content .e9theme-layout4-main {background-color:${main.background || '#e8edf4'};} `);

    return css.join('');
};

/**
 * 设置E9主题样式
 *
 * @param data E9主题样式配置数据
 */
export const setE9ThemeStyle = (data,leftMenuMode) => {
    const css = data ? getE9ThemeCss(data,leftMenuMode) : '';
    if (jQuery('#theme-style') && jQuery('#theme-style').length) {
        jQuery('#theme-style').html(css);
    } else {
        jQuery(jQuery('head')[0]).append(`<style id="theme-style" type="text/css">${css}</style>`);
    }
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/util/themeUtil.js